import React, { useEffect, useState } from "react";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import CookieSettings, {
    CookieSettingsProps,
} from "web/react/components/cookie-settings/cookie-settings";
import withReduxProvider from "web/react/redux-provider";
import { closeOverlay } from "web/redux/ducks/cookie-settings";
import { ReduxStoreState } from "web/redux/store";
import analytics from "web/script/analytics/analytics";

interface CookieSettingsContainerProps {
    isOpen?: boolean;
    onModalClose?: () => void;
}

function extractState(state: ReduxStoreState): boolean {
    return state.cookieSettingsReducer.overlayIsOpen;
}

function CookieSettingsContainer({
    isOpen,
    onModalClose,
}: CookieSettingsContainerProps): JSX.Element {
    const dispatch = useDispatch();
    const [defaultIsOpen, setDefaultIsOpen] = useState(false);
    const settingsOverlayIsOpen = useReduxSelector(extractState);

    useEffect(() => {
        setDefaultIsOpen(settingsOverlayIsOpen);
    }, [settingsOverlayIsOpen]);

    function defaultOnClose(): void {
        dispatch(closeOverlay());
        setDefaultIsOpen(false);
    }

    let eventLabel;
    let cookieSettingsProps: CookieSettingsProps;
    if (typeof isOpen === "boolean" && onModalClose) {
        eventLabel = "banner";

        cookieSettingsProps = {
            isOpen: isOpen,
            onModalClose: onModalClose,
        };
    } else {
        eventLabel = "footer";

        cookieSettingsProps = {
            isOpen: defaultIsOpen,
            onModalClose: defaultOnClose,
        };
    }

    useEffect(() => {
        if (cookieSettingsProps.isOpen) {
            analytics.event({
                category: "cookie_settings",
                action: "shown",
                label: eventLabel,
            });
        }
    }, [cookieSettingsProps.isOpen, eventLabel]);

    return <CookieSettings {...cookieSettingsProps} />;
}

export default withReduxProvider(CookieSettingsContainer);
